<div class="tw-container tw-flex tw-items-center tw-justify-center tw-py-10" [ngClass]="{'tw-animate-pulse': loading}">
  <div class="uw-fields-container">
    @if(user?._metadata?.resellerOwner){
    <mat-toolbar class="!tw-py-2">
      <div class="tw-self-start tw-me-8">
        <h6>My Customers' Workspaces</h6>
      </div>
    </mat-toolbar>
    }
    @else if(user?.isApproved) {

    @if(!onboarded) {
    <mat-card>
      <mat-card-content>
        <div class="tw-flex tw-leading-relaxed tw-gap-3 tw-w-full tw-justify-between">
          <div class="tw-flex tw-gap-4 tw-flex-col">
            <div class="tw-font-bold">Dear {{user?.profile?.['firstName'] || user?.profile?.['name'] || 'customer'}},
            </div>
            <div>
              Your account has been approved. You can proceed to setup your account.
            </div>
          </div>
          <div class="tw-mt-auto">
            <p-button label="Setup your account" icon="pi pi-cog" severity="primary"
              routerLink="/account/onboarding"></p-button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    } @else {
    <mat-toolbar class="!tw-py-2">
      <div class="tw-self-start tw-me-8">
        <h6>My Workspaces</h6>
      </div>
      @if(onboarded){
      <div class="tw-flex tw-flex-col tw-gap-1 tw-self-start tw-items-end">
        @if(freeWorkspaces) {
        @let count = ownedWorkspaces?.length||0;
        <p-progressBar [value]="(usedFreeWorkspaces*100/freeWorkspaces)" class="tw-min-w-52">
          <ng-template pTemplate="content">
            @if(count <= freeWorkspaces){ <span>{{count}} / {{freeWorkspaces}} free</span>
              } @else {
              <span>{{freeWorkspaces}} free + {{count-freeWorkspaces}} extra</span>
              }
          </ng-template>
        </p-progressBar>
        @if(usedFreeWorkspaces >= freeWorkspaces){
        <div class="tg-sm text-warning">You've reached free workspace allowance.
          @if(canCreateWorkspace){
          <div>Extra workspaces will cost <strong>{{workspacePrice|currency}}</strong> per month</div>
          }
          <!-- @if(canCreateWorkspace) {
          <p-button label="Upgrade" icon="pi pi-arrow-right" routerLink="/account/billing" disabled></p-button>
          } -->

        </div>
        } @else {
        <div class="tg-sm text-muted">{{usedFreeWorkspaces}} / {{freeWorkspaces}} free workspaces used</div>
        }
        }
        <p-button (click)="newWorkspace()" size="small" label="Workspace" icon="pi pi-plus" [outlined]="true"
          [disabled]="!user?.onboarded?.includes('complete') || !canCreateWorkspace"></p-button>
        @if(!canCreateWorkspace && !loading){
        <p class="text-warning">
          <i class="pi pi-exclamation-triangle"></i> You have reached the limit of workspaces you can create.

        </p>
        }
      </div>
      }

    </mat-toolbar>
    }
    }
    @if(ownedWorkspaces?.length){
    <div class="uw-list-card-container">
      @for(workspace of ownedWorkspaces; track $index) {
      <ng-container
        *ngTemplateOutlet="workspaceTemplate; context: {workspace: workspace, disabled: !onboarded}"></ng-container>
      }
    </div>
    }
    @if(showInvited){
    @if(joinedWorkspaces?.length){
    <mat-toolbar class="!tw-py-2">
      <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
        <h5>Workspaces I’ve Joined</h5>
      </div>
    </mat-toolbar>
    <div class="uw-list-card-container">
      @for(workspace of joinedWorkspaces; track $index) {
      <ng-container *ngTemplateOutlet="workspaceTemplate; context: {workspace: workspace,type:'joined'}"></ng-container>
      }
    </div>
    } @else if(currentPlan?.onboarding?.enabled){
    <button mat-button color="primary" (click)="autoOnboard()" class="tw-mt-4 tw-w-full" [disabled]="loading">
      <mat-icon class="tw-mr-2">check_circle</mat-icon>
      Create Workspace
    </button>
    }
    @if(invitedWorkspaces?.length){
    <mat-toolbar class="!tw-py-2">
      <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
        <h5>Pending Invitations</h5>
      </div>
    </mat-toolbar>
    <div class="uw-list-card-container">
      @for(workspace of invitedWorkspaces; track $index) {
      <ng-container
        *ngTemplateOutlet="workspaceTemplate; context: {workspace: workspace,type:'invitation'}"></ng-container>
      }
    </div>
    }
    }
  </div>

</div>
<ng-template #workspaceTemplate let-workspace="workspace" let-type="type" let-disabled="disabled">
  <mat-card class="tw-min-w-72">
    <mat-card-header>
      <mat-card-title>
        @if(workspace.name){
        {{workspace.name}}
        }
        @else { <div class="text-muted tw-italic">{{'[New Workspace]'}}</div> }
      </mat-card-title>
      @if(workspace.settings?.['company_name']){
      <mat-card-subtitle>{{workspace.settings['company_name']}}</mat-card-subtitle>
      }
    </mat-card-header>
    <mat-card-content>
      <div class="uw-fields-container tw-text-center tw-justify-between tw-h-full">
        @let ready = workspace.onboarded?.includes('completed');
        @if(!ready) {
        <div class="tw-self-start">
          <div class="uw-tag uw-tag-warning">Needs Onboarding</div>
        </div>
        }
        <div class="p-fluid tw-mt-auto">
          @switch (type) {
          @case ('invitation'){
          <p-button (click)="joinWorkspace(workspace)" label="Accept and join" icon="pi p-sign-in "
            [loading]="loading"></p-button>
          }
          @case ('joined'){
          <p-button (click)="setWorkspace(workspace)" label="Select" icon="pi p-sign-in " [loading]="loading"
            [disabled]="disabled || !ready"></p-button>
          }
          @default {
          <p-button (click)="setWorkspace(workspace)" label="Select" icon="pi p-sign-in " [loading]="loading"
            [disabled]="disabled"></p-button>
          }
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>


</ng-template>

<ng-template #newWorkspaceDialog>
  <div class="tw-flex tw-items-center">
    <div mat-dialog-title>Create workspace</div>
    <button mat-icon-button mat-dialog-close class="tw-ms-auto tw-me-2" (click)="workspace=undefined">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if(workspace){
    <form #form="ngForm" class="uw-fields-container lg:tw-min-w-96">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput id="name" name="name" [(ngModel)]="workspace.name" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Assign Phone Numbers</mat-label>
        <mat-select multiple name="phones" [(ngModel)]="selectedPhonesIds">
          @for (item of availablePhones; track $index) {
          <mat-option [value]="item._id">{{item.friendlyName}}</mat-option>
          }
        </mat-select>
        @if(loadingPhones){
        <mat-icon class="tw-animate-spin" matSuffix>sync</mat-icon>
        }
      </mat-form-field>
      <div class="uw-sticky-bottom-toolbar">
        <p-button label="Create" severity="primary" (click)="createWorkspace()" [disabled]="form.invalid"
          [loading]="loading"></p-button>
      </div>

    </form>
    }
  </mat-dialog-content>
</ng-template>